<template>
    <div class="row classical-result-container-wrapper">
        <div class="col-6 my-3">
            <div class="inner-box p-0 classical-result-row-wrapper">
                <div class="row h-100">
                    <div class="col-7 p-4 d-flex align-items-center">
                        <div class="result-title pl-2">
                            Your Egyptian index is
                            <span :style="{ color: getClassicalColour('egypt') }">
                                {{ result?.egyptians?.index?.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div class="col-5 d-flex align-items-center px-0 pb-3 pb-md-0">
                        <div class="max-w-180">
                            <DoughnutChart v-if="result?.egyptians?.index" :chart-data="chartData" :options="options"
                                :ChartColor="getClassicalColour('egypt')" :centerTitle="''" chartWidth="100%"
                                chartHeight="100%" />
                        </div>

                        <!-- <img src="../../../../assets/images/ancetry/donut.png" alt="Logo" /> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 my-3">
            <div class="inner-box classical-result-row-wrapper">
                <div class="row w-100 align-items-center d-flex">
                    <div class="col-6">
                        <h5 class="text-start">
                            <b>To view a your Egyptian Index Map and more Information</b>
                        </h5>
                        <div class="d-flex justify-content-start">
                            <a href="#" class="my-2 d-block load-btn-result" @click="action">Click Here</a>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="banner-box">
                            <img src="../../../../assets/images/ancetry/map-4.png" alt="Logo" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="inner-box p-4 mb-4">
                <h4><b>Percentile </b></h4>
                <div class="result-percentile align-items-center">
                    <p>
                        Your percentile is derived from comparing your Egyptian result to that of other
                        users on our platform. It essentially reflects the percentage of users whose
                        index score is lower than yours.
                    </p>
                    <p>
                        You are in the {{ result?.egyptians?.percentile }}'th percentile, which means your index score is higher than
                        {{ result?.egyptians?.percentile }}% of the users in our system. This allows you to gauge your position
                        relative to the broader Living DNA user base.
                    </p>
                </div>
                <div class="d-flex align-items-center justify-content-center mt-3">
                    <div class="">
                        <div class="d-flex">
                            <span class="result-barchart-title">Egyptian - </span><span
                                class="result-barchart-percent">{{ result?.egyptians?.percentile }}</span>
                        </div>
                        <BarChart class="flex-shrink-0" :percentile="result?.egyptians?.percentile" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="inner-box mt-3">
                <div class="inner-content">
                    <h4 class="mb-4"><b>{{ understanding.heading }}</b></h4>
                    <div v-html="understanding.text"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, defineProps, computed } from "vue";
import DoughnutChart from "@/components/charts/Doughnut.vue";
// import { getRequiredContent } from "@/composables/useClassicalContent";
import { getClassicalColour, getRequiredContent } from "@/composables/useClassicalContent";
// import { useLoading } from "@/composables/useLoading";
// import ArchaicResultsPercentile from "@/views/archaic/ArchaicResultsPercentile.vue";
import BarChart from "@/components/charts/BarChart.vue";
import store from "@/store/index";
import { defineEmits } from "vue";

const emit = defineEmits(["action"]);
const action = () => {
    emit("action");
};
defineProps({
    vikingResult: Object,
});

// const { loadingStatus, finishLoading } = useLoading();
const understanding = ref({});
const result = store.getters.result;

getRequiredContent(["understanding-your-results"])
    .then(([understandingResult]) => {
        understanding.value = understandingResult;
    })
    .then();

const options = {
    cutout: "70%",
    radius: "100%",
    responsive: true,
    maintainAspectRatio: true,
};

const chartData = computed(() => ({
    cutoutPercentage: 10,
    datasets: [
        {
            data:
                result?.egyptians?.index <= 100
                    ? [result?.egyptians?.index, 100 - result?.egyptians?.index]
                    : [100, 0],
            backgroundColor: [getClassicalColour("egyptian"), "#ddd"],
        },
    ],
    labels: [],
}));
</script>
